import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEditQuizMutation } from "../../../../features/quiz/quizApi";
import { useGetVideosQuery } from "../../../../features/videos/videosApi";
import SelectList from "../../../ui/SelectList";
import MessageToast from "../../../ui/MessageToast";

export default function EditQuizForm({ quiz }) {
	const {
		id,
		question: initialQuestion,
		video_id: initialVideoId,
		options: initialOptions,
	} = quiz;

	const [question, setQuestion] = useState(initialQuestion);
	const [video_id, setVideoId] = useState(initialVideoId);
	const [options, setOptions] = useState(initialOptions);

	const { data: videos, isSuccess: isGetVideosQuerySuccess } =
		useGetVideosQuery() || {};

	let videosSelectOptions = [];
	if (isGetVideosQuerySuccess) {
		videosSelectOptions = videos.map((video) => ({
			id: video.id,
			text: video.title,
		}));
	}

	const navigate = useNavigate();
	const [
		editQuiz,
		{
			isLoading: isEditQuizLoading,
			isError: isEditQuizError,
			isSuccess: isEditQuizSuccess,
		},
	] = useEditQuizMutation() || [];

	useEffect(() => {
		if (isEditQuizSuccess) {
			navigate("/admin/quizzes");
		}
	}, [isEditQuizSuccess, navigate]);

	const handleFormSubmit = (e) => {
		e.preventDefault();
		const videoTitle = videos.find((v) => v.id == video_id)?.title;

		let quizData = {
			question,
			video_id: Number(video_id),
			video_title: videoTitle,
			options,
		};
		editQuiz({ id, data: quizData });
	};

	const handleOptionChange = (value, property, index) => {
		setOptions((prev) => {
			let newOptions = prev.map((opt) => ({ ...opt }));
			newOptions[index][property] = value;
			return newOptions;
		});
	};

	return (
		<>
			<div>
				<h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
					Update Quiz
				</h2>
			</div>
			<form onSubmit={handleFormSubmit} className="mt-8 space-y-6">
				<div className="rounded-md shadow-sm ">
					<div>
						<label className="font-bold">Question:</label>
						<input
							value={question}
							onChange={(e) => setQuestion(e.target.value)}
							id="question"
							name="question"
							type="question"
							autoComplete="question"
							required
							className="login-input rounded-t-md"
							placeholder="Write question"
						/>
					</div>
					<div className="mt-4">
						<label className="font-bold">
							Select video to attach:
						</label>
						<SelectList
							options={videosSelectOptions}
							value={video_id}
							setValue={setVideoId}
							defaultText="Select video"
							className="login-input rounded-t-md"
							required
						/>
					</div>
					<h2 className="mt-4 font-bold">Prepare options:</h2>

					<div className="options-container">
						<div className="option-sigle">
							<div className="option-tag">
								<span className="option-name">A</span>
								<span>
									<input
										checked={options[0].isCorrect}
										onChange={(e) =>
											handleOptionChange(
												!options[0].isCorrect,
												"isCorrect",
												0
											)
										}
										type="checkbox"
										className="option-checkbox"
									/>
									Is correct
								</span>
							</div>
							<textarea
								value={options[0].option}
								onChange={(e) =>
									handleOptionChange(
										e.target.value,
										"option",
										0
									)
								}
								type="text"
								className="option-input"
								required
							/>
						</div>
						<div className="option-sigle">
							<div className="option-tag">
								<span className="option-name">B</span>
								<span>
									<input
										checked={options[1].isCorrect}
										onChange={(e) =>
											handleOptionChange(
												!options[1].isCorrect,
												"isCorrect",
												1
											)
										}
										type="checkbox"
										className="option-checkbox"
									/>
									Is correct
								</span>
							</div>
							<textarea
								value={options[1].option}
								onChange={(e) =>
									handleOptionChange(
										e.target.value,
										"option",
										1
									)
								}
								type="text"
								className="option-input"
								required
							/>
						</div>
						<div className="option-sigle">
							<div className="option-tag">
								<span className="option-name">C</span>
								<span>
									<input
										checked={options[2].isCorrect}
										onChange={(e) =>
											handleOptionChange(
												!options[2].isCorrect,
												"isCorrect",
												2
											)
										}
										type="checkbox"
										className="option-checkbox"
									/>
									Is correct
								</span>
							</div>
							<textarea
								value={options[2].option}
								onChange={(e) =>
									handleOptionChange(
										e.target.value,
										"option",
										2
									)
								}
								type="text"
								className="option-input"
								required
							/>
						</div>
						<div className="option-sigle">
							<div className="option-tag">
								<span className="option-name">D</span>
								<span>
									<input
										checked={options[3].isCorrect}
										onChange={(e) =>
											handleOptionChange(
												!options[3].isCorrect,
												"isCorrect",
												3
											)
										}
										type="checkbox"
										className="option-checkbox"
									/>
									Is correct
								</span>
							</div>
							<textarea
								value={options[3].option}
								onChange={(e) =>
									handleOptionChange(
										e.target.value,
										"option",
										3
									)
								}
								type="text"
								className="option-input"
								required
							/>
						</div>
					</div>
				</div>

				<div className="flex justify-center">
					<button
						disabled={isEditQuizLoading}
						type="submit"
						className="group relative flex justify-center py-2 px-4 border border-transparent  font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
					>
						Update
					</button>
				</div>
			</form>

			{isEditQuizError && (
				<MessageToast
					message="There was an error editing quiz"
					type="error"
					delay={3000}
				/>
			)}
		</>
	);
}
